export default from './CustomEdit';



// WEBPACK FOOTER //
// ./src/containers/Bookings/customEdit/index.js